import React from "react"
function Item ({ user, errorItem }) {
    return (
        <div style={{ ...style.line }}>
            <div style={{ ...style.cell, width: '6%' }}>
                {`מזהה: ${user.id || ''}`}
            </div>
            <div style={{ ...style.cell, width: '9%' }}>
                {`שם פרטי: ${user.first_name}`}
            </div>
            <div style={{ ...style.cell, width: '9%' }}>
                {`שם משפחה: ${user.last_name}`}
            </div>
            <div style={{ ...style.cell, width: '9%' }}>
                {`טלפון: ${user.phone}`}
            </div>
            <div style={{ ...style.cell }}>
                {`אימייל: ${user.email}`}
            </div>
            <div style={{ ...style.cell, width: '9%' }}>
                {`מ. זהות: ${user.identity}`}
            </div>
            <div style={{ ...style.cell, width: '9%' }}>
                {`ת. לידה: ${user.birthday}`}
            </div>
            <div style={{ ...style.cell, width: '6%' }}>
                {`קופ״ח: ${user.hmo_id}`}
            </div>
            <div style={{ ...style.cell, width: '6%' }}>
                {`שב״ן: ${user.hmo_plan_id}`}
            </div>
            {errorItem &&
            <div style={{ ...style.cell,  width: '14%' }}>
                {`${user.typeErr}`}
            </div>}
        </div>
    )
}

const style = {
    line: { display: 'flex', justifyContent: 'space-between', width: '100%', height: '50px', marginBottom: '28px' },
    cell: { width: '11%' }
}

export default Item